export const authInitialState = {
    isAnonymous: false,
    isLoggedIn: false,
    isPending: false,
    hasExpiredLogin: false,
    access_token: null,
    parsedAccessToken: null,
    error: null,
};
//# sourceMappingURL=initialState.js.map